import {AddReceiptResponse, LoyaltyData, LoyaltyHistory, PartnerPromotion, QrCode, ShareId} from "./loaylty-data";
import config from "../../config";
import {Session} from "../customer/customer";

export interface ILoyaltyService {
  getLoyaltyData(session: Session): Promise<LoyaltyData>
  getHistory(session: Session): Promise<LoyaltyHistory>
  getShareId(session: Session): Promise<ShareId>
  getLoyaltyQRCode(session: Session, rewardIds: string[], couponIds: string[]): Promise<QrCode>
  addReceipt(session: Session, receiptNumber: string): Promise<AddReceiptResponse>
  checkPartnerPromotion(session: Session, promotionId: string): Promise<PartnerPromotion>
  consumePartnerPromotion(session: Session, promotionId: string)
}

export async function getLoyaltyData(session:Session): Promise<LoyaltyData> {
  let url = `${config.loyaltyServiceUrl}/${session.customerId}/details`;
  if (isInternetExplorer()) {
    url += `?t=${new Date()}`
  }
  const result = await fetch(url, {
    headers: {
      'NY-SESSION-TOKEN': `${session.token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    }
  });

  if (!result.ok) {
    // noinspection ExceptionCaughtLocallyJS
    throw new Error("[get-loyalty-data] response was not ok: " + result.statusText);
  }

  const data = await result.json();
  return new LoyaltyData(data);
}

export async function getHistory(session: Session): Promise<LoyaltyHistory> {
  let url = `${config.loyaltyServiceUrl}/${session.customerId}/history`;
  if (isInternetExplorer()) {
    url += `?t=${new Date()}`
  }
  const result = await fetch(url, {
    headers: {
      'NY-SESSION-TOKEN': `${session.token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    }
  });

  if (!result.ok) {
    // noinspection ExceptionCaughtLocallyJS
    throw new Error("[get-loyalty-history] response was not ok: " + result.statusText);
  }

  const data = await result.json();
  return new LoyaltyHistory(data);
}

export async function getShareId(session: Session): Promise<ShareId> {
  const result = await fetch(`${config.loyaltyServiceUrl}/${session.customerId}/shareId`, {
    headers: {
      'NY-SESSION-TOKEN': `${session.token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    }
  });

  if (!result.ok) {
    // noinspection ExceptionCaughtLocallyJS
    throw new Error("[get-loyalty-shareId] response was not ok: " + result.statusText);
  }

  const data = await result.json();
  return new ShareId(data);
}

export async function getLoyaltyQRCode(session: Session, rewardIds: string[], couponIds: string[]): Promise<QrCode> {
  let url = `${config.loyaltyServiceUrl}/${session.customerId}/qrCode?`;
  if (rewardIds && rewardIds.length > 0) {
    url = `${url}rewardIds=${rewardIds.join(',')}`;
    if (couponIds && couponIds.length > 0) {
      url = `${url}&`;
    }
  }

  if (couponIds && couponIds.length > 0) {
    url = `${url}couponIds=${couponIds.join(',')}`;
  }
  const result = await fetch(
    url, {
      headers: {
        'NY-SESSION-TOKEN': `${session.token}`,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      method: 'Get',
    });

  if (!result.ok) {
    throw new Error("[get-loyalty-qrCode] response was not ok: " + result.statusText);
  }

  const data = await result.json();
  return new QrCode(data);
}

export async function addReceipt(session: Session, receiptNumber: string): Promise<AddReceiptResponse> {
  const result = await fetch(`${config.loyaltyServiceUrl}/${session.customerId}/addReceipt`, {
      method: 'PUT',
      headers: {
        'NY-SESSION-TOKEN': `${session.token}`,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify({receiptNumber: receiptNumber}),
    });

  if (!result.ok) {
    throw await result.json();
  }

  const data = await result.json();
  return new AddReceiptResponse(data);
}

export async function checkPartnerPromotion(session: Session, promotionId: string): Promise<PartnerPromotion> {
  const result = await fetch(`${config.loyaltyServiceUrl}/${session.customerId}/partnerPromotion/${promotionId}/code`, {
    method: 'GET',
    headers: {
      'NY-SESSION-TOKEN': `${session.token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    },
  });

  if (!result.ok) {
    throw new Error("[checkPartnerCoupon] response was not ok: " + result.statusText);
  }

  const data = await result.json();
  return new PartnerPromotion(data);
}

export async function consumePartnerPromotion(session: Session, promotionId: string): Promise<PartnerPromotion> {
  const result = await fetch(`${config.loyaltyServiceUrl}/${session.customerId}/partnerPromotion/${promotionId}/consume`, {
    method: 'POST',
    headers: {
      'NY-SESSION-TOKEN': `${session.token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    },
  });

  if (!result.ok) {
    throw new Error("[consumePartnerPromotion] response was not ok: " + result.statusText);
  }

  const data = await result.json();
  return new PartnerPromotion(data);
}

function isInternetExplorer() {
  return navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))
}


